import { ArrowUpCircleIcon, ArrowDownCircleIcon, Bars2Icon } from "@heroicons/react/20/solid";

/**
 * POW Indicator Config - uses same colors as PriorityAlignmentOffsetIndicator
 * Returns background color and icon based on POW value
 */
export const getPowConfig = (value: number) => {
  if (value > 1) return { bg: "#1d8510", icon: ArrowUpCircleIcon };
  if (value >= 0.95 && value <= 1.05) return { bg: "#6b7280", icon: Bars2Icon };
  if (value >= 0.7) return { bg: "#F2994A", icon: ArrowDownCircleIcon };
  return { bg: "#f02e2e", icon: ArrowDownCircleIcon };
};
